/**
 * @copyright (C) 2023, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Heeseok Shin (hsshin@rsupport.com)
 *
 * @description
 *
 * @created at Tue May 23 2023
 **/

import { Theme, css, keyframes } from "@emotion/react";
import styled from "@emotion/styled";
import { ZIndex } from "@/frameworks/core/commons";

import { Column, Row, Typography } from "@/frameworks/designStuff/components";

const fadeOutBackground = (theme: Theme) => keyframes`
  0% {
    background-color: ${theme.colors.secondary_80_8};
  }
  100% {
    background-color: transparent;
  }
`;

export const HeaderIconList = styled(Row.div)`
	gap: 3px;
`;

export const FieldLabel = styled(Typography.p)`
	color: #6a6d73;
`;

export const Body = styled(Column)<{ variant: ChatUI.Size }>`
	position: relative;
	height: 100%;
	padding: ${({ variant }) => (variant === "fullSize" ? "20px 44px" : variant === "miniPopup" ? "0 2px 0 0" : "0")};
	width: -webkit-fill-available;
	overflow-y: hidden;
`;

export const ThreadTotal = styled.div<{ variant: ChatUI.Size }>`
	position: sticky;
	width: 100%;
	height: ${({ variant }) => variant === "fullSize" && "56px"};
	top: 0;
	z-index: 10;
	padding: ${({ variant }) => (variant === "fullSize" ? "15px 20px" : "12px 12px 12px 8px")};
	background-color: ${({ theme, variant }) => variant === "miniPopup" && theme.colors.neutral_00_100};
	border-bottom: 1px solid ${({ theme }) => theme.colors.neutral_50_20};
`;

export const ThreadTitle = styled(Column)`
	width: 100%;
	animation: ${({ theme }) => fadeOutBackground(theme)} 3s ease-out forwards;
`;

export const ThreadDivider = styled(Row)`
	width: 100%;
	padding: 10px 16px 20px 16px;
`;

export const Line = styled.div`
	flex: 1;
	border-top: 1px dashed ${({ theme }) => theme.colors.neutral_50_30};
`;

export const NoticeLayer = styled(Column)<{ variant: ChatUI.Size }>`
	position: absolute;
	justify-content: center;

	${({ variant }) => {
		switch (variant) {
			case "fullSize": {
				return FullSizeChatNoticeCSS();
			}
			case "miniPopup": {
				return MiniChatNoticeCSS();
			}
			case "transparent": {
				return SpaceChatNoticeCSS();
			}
		}
	}}
`;

const MiniChatNoticeCSS = () => css`
	top: 0px;
	left: 0px;
	width: 100%;
	z-index: ${ZIndex.CHAT_POPUP + 1};
`;
const FullSizeChatNoticeCSS = () => css`
	top: 5px;
	left: 50%;
	transform: translateX(-50%);
	width: calc(100% - 120px);
	z-index: ${ZIndex.POPUP};
`;
const SpaceChatNoticeCSS = () => css`
	position: relative;
	margin-top: 4px;
	width: 100%;
`;
